/* global BUILD_TYPE */
/* eslint global-require: "off" */
import 'focus-visible';
import 'intersection-observer';

if (BUILD_TYPE === 'legacy') {
    require('custom-event-polyfill');
    require('element-closest-polyfill');
    require('core-js/es/object/entries');
    require('core-js/es/promise/finally');
    require('mdn-polyfills/Node.prototype.append');
    require('object-fit-images')();
    require('picturefill');
    require('whatwg-fetch');
}
